import { ErrorMessage } from '@aon/aon-tws-common-ui/build/lib/components/Common';
import { IHierarchyNodeActions, IHierarchySearchActionCreators } from '@aon/tws-common-ui-hierarchy';
import * as React from 'react';
import { CardLayout } from '../../components/common';
import ContentConstants from '../../contentConstants';
import { AudienceSourceType, ExternalApplicationType, IAudienceSourceVm } from '../../models';
import { ActionCreators, AudienceDetailsState } from '../../store/AudienceDetailsStore';
import { ActionCreators as CommonHierarchyActionCreators, TCommonHierarchyState } from '../../store/CommonHierarchyStore';
import { ActionCreators as DistributionContactActionCreators, IDistributionContactState } from '../../store/DistributionContactStore';
import { ActionCreators as DistributionFileActionCreators, IDistributionFileState } from '../../store/DistributionFileStore';
import { ActionCreators as DistributionHierarchyActionCreators, IDistributionHierarchyState } from '../../store/DistributionHierarchyStore';
import { ActionCreators as EmailActionCreators, IEmailState } from '../../store/EmailStore';
import * as EmailTemplateActionCreators from '../../store/EmailTemplateSlice';
import { ActionCreators as ExternalHierarchyActionCreators, IExternalHierarchyState } from '../../store/ExternalHierarchyStore';
import { ISurveyParticipantState, ActionCreators as SurveyParticipantActionCreators } from '../../store/SurveyParticipantStore';
import { AudienceMode } from '../audiences/AudienceMode';
import { DistributionOptions } from './DistributionOptions';
import { GroupBasedLinks } from './hierarchy/hierarchyStructure/GroupBasedLinks';
import { HierarchyNodeSelection } from './hierarchy/hierarchyStructure/HierarchyNodeSelection';

interface IDistributionOptionWrapperProps {
	audienceSource?: IAudienceSourceVm;
	loadingAudienceSource: boolean;
	externalApplicationType?: ExternalApplicationType;
	mode: AudienceMode;
	surveyId: number;
	surveySupportedCultures?: string[];
}

export type DistributionOptionWrapperParams = IDistributionOptionWrapperProps &
	typeof ActionCreators &
	AudienceDetailsState &
	typeof EmailActionCreators &
	IEmailState &
	typeof EmailTemplateActionCreators &
	EmailTemplateActionCreators.IEmailTemplateState &
	typeof DistributionFileActionCreators &
	IDistributionFileState &
	typeof DistributionContactActionCreators &
	IDistributionContactState &
	typeof SurveyParticipantActionCreators &
	ISurveyParticipantState &
	typeof ExternalHierarchyActionCreators &
	IExternalHierarchyState &
	IHierarchySearchActionCreators &
	IHierarchyNodeActions &
	typeof DistributionHierarchyActionCreators &
	IDistributionHierarchyState &
	typeof CommonHierarchyActionCreators & { hierarchy: TCommonHierarchyState; isOpen: boolean };

export class DistributionOptionWrapper extends React.Component<DistributionOptionWrapperParams, {}> {
	constructor(props: DistributionOptionWrapperParams) {
		super(props);
	}

	public componentWillUnmount() {
		this.props.InitState();
	}

	public render() {
		const { audienceSource, loadingAudienceSource } = this.props;

		switch (audienceSource?.audienceSourceType) {
			case AudienceSourceType.FileUpload:
				return <DistributionOptions {...this.props} />;
			case AudienceSourceType.Hierarchy:
				return <GroupBasedLinks {...this.props} />;
			case AudienceSourceType.Hris:
				return <HierarchyNodeSelection {...this.props} />;
			default:
				return (
					<CardLayout loading={loadingAudienceSource} title={ContentConstants.DISTRIBUTIONOPTIONS_PAGE_TITLE}>
						<ErrorMessage>{ContentConstants.SELECT_AUDIENCE_SOURCE}</ErrorMessage>
					</CardLayout>
				);
		}
	}
}
